
export class ContextualHelpModel{
  functionality:string;
  descriptionText:string;
  link: string;
  linkName:string;
  selected: boolean = false;
  isEnabled: boolean = false;
  transformDTOInModel(contextualHelp: ContextualHelpDTO){
    this.functionality = contextualHelp.functionality;
    this.descriptionText = contextualHelp.descriptionText;
    this.link = contextualHelp.link;
    this.selected = false;
  }

}
export class ContextualHelpDTO{
  functionality:string;
  descriptionText:string;
  link: string;
  transformModelInDTO(contextualHelp: ContextualHelpDTO){
    this.functionality = contextualHelp.functionality;
    this.descriptionText = contextualHelp.descriptionText;
    this.link = contextualHelp.link;
  }
}
